<template>
  <div class="file-preview">
    <div class="file-preview-inner">
      <div class="file-preview-name">
        {{ name.length > 20 ? `${name.substring(0, 20)}...` : name }}
      </div>
      <div class="file-preview-size">{{ size }}</div>
      <div class="file-preview-image">
        <img :src="type === 'pdf' ? pdf : doc" :alt="type" />
        <span>file</span>
      </div>

      <div class="file-preview-action">
        <f7-button>Open</f7-button>
      </div>
    </div>
  </div>
</template>

<script>
import doc from '@/static/doc.svg';
import pdf from '@/static/pdf.svg';

export default {
  name: 'FileCard',
  props: {
    name: {
      type: String,
      default: 'Document'
    },
    src: {
      type: String,
      default: 'Document'
    },
    size: {
      type: [Number, String],
      default: 'Indeterminately'
    },
    type: {
      type: String,
      default: 'doc',
      validator(value) {
        return ['doc', 'docx', 'pdf'].includes(value);
      }
    }
  },

  data() {
    return {
      doc,
      pdf
    };
  }
};
</script>

<style lang="scss" scoped>
.file-preview {
  background-color: rgb(241, 241, 241);
  color: #000000;
  padding: 15px;

  &-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 170px;
  }

  &-name {
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
  }

  &-size {
    margin-top: 3px;
    font-weight: 300;
    font-size: 14px;
    color: rgb(144, 147, 151);
  }

  &-image {
    margin-top: 15px;
    display: flex;
    align-items: center;

    img {
      width: 45px;
    }

    span {
      margin-left: 10px;
    }
  }

  &-action {
    margin-top: 15px;
    width: 100%;

    --f7-button-height: 40px;
  }
}
</style>
